module.exports = __webpack_public_path__ + "static/media/balloons.5417b520.jpeg";